import { t, useLang } from '../i18n';
import { TARGET_LABELS } from '../types';
/**
 * QRPage — 字幕URL QRコード印刷ページ (/qr)
 *
 * 参加者配布用・会場投影用のQRコードを大きく表示して印刷できる
 */

export default function QRPage() {
  useLang();
  const params = new URLSearchParams(window.location.search);
  const captionUrl = params.get('url') ?? `${window.location.origin}/caption`;
  const qrApiUrl = `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(captionUrl)}`;
  // 言語ごとのQR（例: langs=ja,zh）。指定がなければ従来どおり1つ
  const langs = (params.get('langs') ?? '').split(',').map((x) => x.trim()).filter(Boolean);
  const qrFor = (code: string) => {
    const u = `${captionUrl}${captionUrl.includes('?') ? '&' : '?'}lang=${code}`;
    return { url: u, img: `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(u)}` };
  };

  const handlePrint = () => window.print();

  return (
    <div style={{
      minHeight: '100vh',
      background: '#fff',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
      fontFamily: 'sans-serif',
    }}>
      <style>{`
        @media print {
          .no-print { display: none !important; }
          body { margin: 0; }
        }
      `}</style>

      <div style={{ textAlign: 'center', maxWidth: langs.length > 1 ? 900 : 480 }}>
        <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🌐</div>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '0.25rem', color: '#111827' }}>
          Amo Live Translator
        </h1>
        <p style={{ color: '#6b7280', fontSize: '1rem', marginBottom: '2rem' }}>
          {t('このQRコードを読み取ると、リアルタイム字幕が表示されます', 'Scan this QR code to view live captions on your phone')}
        </p>

        {langs.length > 1 ? (
          <div style={{ display: 'flex', gap: '1.5rem', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '1.5rem' }}>
            {langs.map((code) => (
              <div key={code} style={{ border: '2px solid #e5e7eb', borderRadius: 16, padding: '1.25rem', background: '#fff', boxShadow: '0 4px 16px rgba(0,0,0,0.08)' }}>
                <div style={{ fontSize: '1.4rem', fontWeight: 'bold', color: '#111827', marginBottom: '0.75rem' }}>{TARGET_LABELS[code] ?? code}</div>
                <img src={qrFor(code).img} alt={TARGET_LABELS[code] ?? code} width={240} height={240} style={{ display: 'block' }} />
              </div>
            ))}
          </div>
        ) : (
        <div style={{
          border: '2px solid #e5e7eb',
          borderRadius: 16,
          padding: '1.5rem',
          display: 'inline-block',
          background: '#fff',
          boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
          marginBottom: '1.5rem',
        }}>
          <img
            src={qrApiUrl}
            alt={t('字幕QRコード', 'Caption QR code')}
            width={280}
            height={280}
            style={{ display: 'block' }}
          />
        </div>
        )}

        <p style={{
          fontSize: '0.85rem',
          color: '#374151',
          background: '#f3f4f6',
          padding: '0.5rem 1rem',
          borderRadius: 8,
          wordBreak: 'break-all',
          marginBottom: '1.5rem',
        }}>
          {`${window.location.origin}/caption`}
        </p>

        <div className="no-print" style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={handlePrint}
            style={{
              background: '#1d4ed8',
              color: 'white',
              border: 'none',
              borderRadius: 8,
              padding: '0.75rem 2rem',
              fontSize: '1rem',
              cursor: 'pointer',
              fontWeight: 'bold',
            }}
          >
            {t('🖨️ 印刷する', '🖨️ Print')}
          </button>
          <button
            onClick={() => window.close()}
            style={{
              background: 'transparent',
              color: '#6b7280',
              border: '1px solid #d1d5db',
              borderRadius: 8,
              padding: '0.75rem 2rem',
              fontSize: '1rem',
              cursor: 'pointer',
            }}
          >
            {t('閉じる', 'Close')}
          </button>
        </div>
      </div>
    </div>
  );
}
